<section class="content">
    <div class="content-block">
        <div class="row clearfix">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card">
                    <div class="header mb-3">
                        <h2><strong>Administration</strong> historique connexion</h2>
                    </div>
                    <div class="body">
                        <section class="section-parametre" [ngBusy]="{
                  busy: busyGet,
                  message: 'Veuillez patienter ...',
                  backdrop: false
                }">
                            <div class="">
                                <div class="row clearfix">
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="card">
                                            <div class="body table-responsive">
                                                <table class="table table-stripped table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="12">
                                                                <div class="row mt-4">

                                                                    <div class="col-md-3 select-container">
                                                                        <ng-select [disabled]="true"
                                                                            [(ngModel)]="filiale_id"
                                                                            placeholder="Choisissez filiale "
                                                                            name="filiale_id" id="filiale_id"
                                                                            [multiple]="false" [closeOnSelect]="true"
                                                                            (change)="getItems()">
                                                                            <ng-option *ngFor="let item of itemsFiliale"
                                                                                [value]="item.id">{{ item?.libelle }}
                                                                            </ng-option>
                                                                        </ng-select>
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <input [(ngModel)]="searchKey"
                                                                            class="form-control custom-input pull-left"
                                                                            placeholder="Rechercher ..."
                                                                            (keyup)="currentPage = 0; getItems()" />
                                                                    </div>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                        <tr class="custom-table-head">
                                                            <th>
                                                                <a style="cursor: pointer"
                                                                    (click)="currentPage = 0; getItems()"
                                                                    title="Actualiser">
                                                                    <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                                                            </th>
                                                            <th>Nom prenoms</th>
                                                            <th>Ip</th>
                                                            <th>Longitude</th>
                                                            <th>Latitude</th>
                                                            <th>Page visitée</th>
                                                            <th>Api sollicitée</th>
                                                            <th>Corps réquete</th>
                                                            <th>Date</th>
                                                            <th class="txt-align-center">Actions</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr *ngFor="let item of items; let indice = index">
                                                            <!-- Main Data Row Content -->
                                                            <td class="txt-align-center">{{ currentPage>1?(((currentPage
                                                                - 1) * this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                                                            <td>{{ item?.nom }} {{ item?.prenom }}</td>
                                                            <td>{{ item?.created_ip_address }}</td>

                                                            <td>{{ item?.longitude}}</td>
                                                            <td>{{ item?.latitude}}</td>
                                                            <td>{{ item?.page_route}}</td>
                                                            <td>{{ item?.request_url}}</td>

                                                            <td (click)="item.showJson = !item.showJson">
                                                                <div class="custom-td-action">
                                                                    <a title="Afficher/Masquer JSON"
                                                                        class="custom-btn-info"
                                                                        [class.active]="item.showJson">
                                                                        <i class="fa" [class.fa-code]="!item.showJson"
                                                                            [class.fa-times]="item.showJson"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            <td >
                                                                {{item?.created_at | dateTimeFormat}}
                                                            </td>
                                                        </tr>

                                                        <!-- JSON Rows for each item -->
                                                        <tr *ngFor="let item of items">
                                                            <td *ngIf="item.showJson" colspan="12">
                                                                <div class="json-viewer">
                                                                    <div class="json-header">
                                                                        <!-- <h6>Données JSON</h6> -->
                                                                        <!-- <button class="btn btn-sm btn-outline-secondary"
                                                                            (click)="copyJson(item)">
                                                                            <i class="fa fa-copy"></i> Copier
                                                                        </button> -->
                                                                    </div>
                                                                    <!-- <pre>{{ item | json }}</pre> -->
                                                                    <pre>{{ item.request_body | json }}</pre>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                    <tfoot>
                                                        <tr *ngIf="items && items.length > 0">
                                                            <td colspan="12">
                                                                <div class="row pagination-part">
                                                                    <div class="col-md-9" style="text-align: center">
                                                                        <pagination [maxSize]="5" [boundaryLinks]="true"
                                                                            [itemsPerPage]="itemsPerPage"
                                                                            [totalItems]="totalItems"
                                                                            [(ngModel)]="currentPage"
                                                                            class="pagination-sm"
                                                                            previousText="&lsaquo;" nextText="&rsaquo;"
                                                                            firstText="&laquo;" lastText="&raquo;"
                                                                            (pageChanged)="pageChanged($event)">
                                                                        </pagination>
                                                                    </div>

                                                                    <div class="col-md-3">
                                                                        <div class="paginator-per-page">
                                                                            <app-element-by-page-paginator
                                                                                (paginationChange)="
                                            changePaginationSize($event)
                                          " [defaultItemPerPage]="itemsPerPage">
                                                                            </app-element-by-page-paginator>

                                                                            <span
                                                                                class="span_total_entree pull-right">Total
                                                                                : {{ totalItems }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr *ngIf="!items || items.length == 0">
                                                            <td colspan="12">
                                                                <div class="col-md-12 txt-align-center">
                                                                    Aucune donnée disponible
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>